import React from 'react';
import { Shape, Row, Col, Body, Tag, Caption, Button, styled, CommonStyles, Image } from '@teko/ds-desktop';
import { format } from 'date-fns';
import { t } from '../../i18n.es.js';
import { PromotionStatus } from '../../types.es.js';
import { trackManually } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PromotionItem = (_a) => {
  var _b = _a, {
    data,
    isHiddenButton = false,
    hightTitle,
    onApplyPromotion,
    onRemovePromotion
  } = _b, props = __objRest(_b, [
    "data",
    "isHiddenButton",
    "hightTitle",
    "onApplyPromotion",
    "onRemovePromotion"
  ]);
  const {
    promotionStatus,
    cartPromotionId,
    imageUrl,
    title,
    description,
    endedAt,
    promotionId,
    promotionCode,
    comboPromotion,
    productSku,
    highlightedDescriptions
  } = data;
  if (promotionStatus === PromotionStatus.FIXED) {
    return !!title ? /* @__PURE__ */ React.createElement(Shape, __spreadValues({
      width: "100%"
    }, props), /* @__PURE__ */ React.createElement(Row, {
      justify: "space-between",
      wrap: false
    }, /* @__PURE__ */ React.createElement(Col, {
      paddingRight: "s12"
    }, /* @__PURE__ */ React.createElement(GiftStyledImage, {
      src: imageUrl,
      width: 16,
      height: 16
    })), /* @__PURE__ */ React.createElement(Col, {
      width: "100%"
    }, title.split("\n").map((t2) => /* @__PURE__ */ React.createElement(Body, {
      level: 1,
      key: t2
    }, t2))))) : null;
  }
  const onClickBtn = () => {
    if (promotionStatus === PromotionStatus.UNSELECTED) {
      trackManually("applyCoupon", "orderPromotionPopup", "n/a", comboPromotion ? JSON.stringify({
        comboPromotion,
        sku: productSku,
        promotionId
      }) : JSON.stringify({ promotionId }));
      return onApplyPromotion == null ? void 0 : onApplyPromotion();
    }
    if (promotionStatus === PromotionStatus.SELECTED && !!cartPromotionId) {
      trackManually("removeCoupon", "orderPromotionPopup", "n/a", comboPromotion ? JSON.stringify({
        comboPromotion,
        sku: productSku,
        promotionId
      }) : JSON.stringify({ promotionId }));
      return onRemovePromotion == null ? void 0 : onRemovePromotion();
    }
  };
  const convertEndedAtTime = (endedAt2) => {
    if (!endedAt2) {
      return "";
    }
    const expiredTime = new Date(endedAt2);
    return format(expiredTime, "dd/MM/yyyy");
  };
  const borderColor = promotionStatus === PromotionStatus.SELECTED ? "primary500" : "divider";
  const backgroundColor = promotionStatus === PromotionStatus.SELECTED ? "primary50" : "white";
  const selectButtonText = t(promotionStatus === PromotionStatus.SELECTED ? t("B\u1ECF ch\u1ECDn") : t("\xC1p d\u1EE5ng"));
  const opacity = promotionStatus === PromotionStatus.DISABLED ? "l" : void 0;
  const disablePromotion = promotionStatus === PromotionStatus.DISABLED;
  const buttonClassName = promotionStatus === PromotionStatus.SELECTED ? `unselect-promotion att-unselect-promotion-${promotionId}` : `apply-promotion att-apply-promotion-${promotionId}`;
  const displayPromotionCode = promotionCode ? (promotionCode == null ? void 0 : promotionCode.length) > 12 ? (promotionCode == null ? void 0 : promotionCode.substring(0, 12)) + "..." : promotionCode : void 0;
  return /* @__PURE__ */ React.createElement(Shape, __spreadValues({
    width: "100%",
    borderStyle: "solid",
    borderRadius: "m",
    borderWeight: "l",
    borderColor,
    backgroundColor,
    padding: "s12",
    opacity
  }, props), /* @__PURE__ */ React.createElement(Row, {
    justify: "space-between",
    wrap: false
  }, /* @__PURE__ */ React.createElement(Col, {
    marginRight: "s12"
  }, /* @__PURE__ */ React.createElement(ImageContainer, {
    backgroundColor: imageContainerBGColor(promotionStatus),
    borderRadius: "s"
  }, /* @__PURE__ */ React.createElement(StyledImage, {
    src: imageUrl
  }))), /* @__PURE__ */ React.createElement(Col, {
    width: "100%",
    style: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
    }
  }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Body, {
    level: 2,
    line: 2,
    style: { whiteSpace: "pre-line" }
  }, displayPromotionCode ? /* @__PURE__ */ React.createElement(Tag, {
    marginRight: "s4",
    content: displayPromotionCode,
    type: "ghost",
    variant: promotionStatus === PromotionStatus.DISABLED ? "default" : "branding"
  }) : null, title), /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "textSecondary",
    line: 2
  }, description), !!(highlightedDescriptions == null ? void 0 : highlightedDescriptions.length) && /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "warning"
  }, highlightedDescriptions.join(", "))), /* @__PURE__ */ React.createElement(Row, {
    marginTop: "s8",
    justify: "space-between",
    align: "bottom"
  }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(Caption, {
    level: 1,
    color: "textSecondary"
  }, t("HSD:"), " ", convertEndedAtTime(endedAt))), !isHiddenButton && /* @__PURE__ */ React.createElement(Button, {
    variant: "link",
    disabled: disablePromotion,
    onClick: onClickBtn,
    className: buttonClassName
  }, selectButtonText)))));
};
const imageContainerBGColor = (promotionStatus) => {
  switch (promotionStatus) {
    case (PromotionStatus.SELECTED || PromotionStatus.UNSELECTED):
      return "primary100";
    default:
      return "tableHeader";
  }
};
const ImageContainer = styled.div`
  ${CommonStyles};
  width: 90%;
  min-width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledImage = styled(Image)`
  max-width: 32px;
  max-height: 32px;
`;
const GiftStyledImage = styled(Image)`
  overflow: initial;
`;

export { PromotionItem };
